import { Link } from "react-router-dom";
import { useCookies } from "react-cookie";
import { useNavigate } from "react-router-dom";

export const NavBar = () => {
  const [cookies, setCookie] = useCookies(["access_token"]);
  const navigate = useNavigate();
  const logout = () => {
    setCookie("access_token", "");
    window.localStorage.removeItem("UserID");
    window.localStorage.removeItem("username");
    navigate("/auth");
  };

  return (
    <div className="xl:flex xl:justify-center">
      <div className="navbar bg-accent text-accent-content xl:my-3 xl:rounded-xl xl:w-[95%]">
        <div className="navbar-start">
          <div className="dropdown">
            <label tabIndex="0" className="btn btn-ghost lg:hidden">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="h-5 w-5"
                fill="none"
                viewBox="0 0 24 24"
                stroke="currentColor"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h8m-8 6h16"
                />
              </svg>
            </label>
            <ul
              tabIndex="0"
              className="menu menu-compact dropdown-content mt-3 p-2 shadow bg-accent rounded-box w-52"
            >
              <li>
                <Link to="/">Home</Link>
              </li>
              {cookies.access_token && (
                <li tabIndex="0">
                  <button className="justify-between">
                    Blogs
                    <svg
                      className="fill-current"
                      xmlns="http://www.w3.org/2000/svg"
                      width="24"
                      height="24"
                      viewBox="0 0 24 24"
                    >
                      <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                    </svg>
                  </button>
                  <ul className="p-2 bg-accent">
                    <li>
                      <Link to="/createnotes">Create Post</Link>
                    </li>
                    <li>
                      <Link to="/savednotes">Saved Post</Link>
                    </li>
                  </ul>
                </li>
              )}
            </ul>
          </div>
          <a href="/" className="btn btn-ghost normal-case text-xl">
            BlogX
          </a>
        </div>
        <div className="navbar-center hidden lg:flex">
          <ul className="menu menu-horizontal px-1">
            <li>
              <Link to="/">Home</Link>
            </li>
            {cookies.access_token && (
              <li tabIndex="0">
                <button className="justify-between">
                  Blogs
                  <svg
                    className="fill-current"
                    xmlns="http://www.w3.org/2000/svg"
                    width="24"
                    height="24"
                    viewBox="0 0 24 24"
                  >
                    <path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" />
                  </svg>
                </button>
                <ul className="p-2 bg-accent">
                  <li>
                    <Link to="/createnotes">Create Post</Link>
                  </li>
                  <li>
                    <Link to="/savednotes">Saved Post</Link>
                  </li>
                </ul>
              </li>
            )}
          </ul>
        </div>
        <div className="navbar-end">
          {!cookies.access_token ? (
            <a
              href="/auth"
              className="btn text-accent-content bg-accent hover:bg-accent-focus"
            >
              Get started
            </a>
          ) : (
            <button
              onClick={logout}
              className="btn text-accent-content bg-accent hover:bg-accent-focus"
            >
              Logout
            </button>
          )}
        </div>
      </div>
    </div>
  );
};
